import { useCreativesConfig } from '@ad-lucy/context/creativesConfig';
import { ThemeProvider as BaseThemeProvider, type Theme } from '@ad-lucy/styled';
import type { ReactElement, ReactNode } from 'react';

import type { KnownBreakpoints } from './types';

type Props = {
  theme: Theme;
  children: ReactNode | ReactNode[];
};

const ThemeProvider = ({ theme, children }: Props): ReactElement => {
  const { breakpoints } = useCreativesConfig();

  return (
    <BaseThemeProvider
      theme={{
        ...theme,
        breakpoints: { ...theme.breakpoints, ...breakpoints },
      }}
    >
      {children}
    </BaseThemeProvider>
  );
};

export type { KnownBreakpoints };
export { ThemeProvider };
